"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rest_api_1 = require("@nimles/rest-api");

var actionTypes_1 = require("../actionTypes");

var actionCreator_1 = require("../../utils/actionCreator");

var populateCart = function populateCart(cart, state) {
  return __awaiter(void 0, void 0, void 0, function () {
    var publicProducts, auth, items, _a;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          publicProducts = state.publicProducts, auth = state.auth;
          _a = cart.items;
          if (!_a) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , Promise.all(cart.items.map(function (item) {
            return __awaiter(void 0, void 0, void 0, function () {
              var product, response;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    if (item.product || !item.productId) return [2
                    /*return*/
                    , item];
                    product = publicProducts.values.find(function (p) {
                      return p.id === item.productId;
                    });
                    if (!product) return [3
                    /*break*/
                    , 1];
                    return [2
                    /*return*/
                    , __assign(__assign({}, item), {
                      product: product
                    })];

                  case 1:
                    return [4
                    /*yield*/
                    , rest_api_1.getPublicProduct({
                      tenantId: auth.tenantId
                    }, item.productId)];

                  case 2:
                    response = _a.sent();
                    return [2
                    /*return*/
                    , __assign(__assign({}, item), {
                      product: response.data
                    })];
                }
              });
            });
          }))];

        case 1:
          _a = _b.sent();
          _b.label = 2;

        case 2:
          items = _a;

          if (items) {
            cart.items = items;
          }

          return [2
          /*return*/
          , cart];
      }
    });
  });
};

var populateCarts = function populateCarts(carts, state) {
  return Promise.all(carts.map(function (cart) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , populateCart(cart, state)];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  }, []));
};
/**
 * Fetches the active cart based on the cartUser or the signed in user. The cartUser should be added as a query parameter.
 * If no active cart is available in Nimles, a new cart is created and posted to Nimles.
 * The new cart belongs to the cartUser or the signed in user.
 * If user is not signed in and no cartUser is provided as a query parameter, a new cartUser (Guid) is generated and added to the card.
 * The cartUser can be saved on the client, e.g. localstorage, and use for future loadActiveCart.
 *
 * @param queryParameters - Query parameters
 * @param fetchProducts - Fetch products
 * @returns The active cart
 */


exports.loadActiveCart = function (queryParameters, fetchProducts) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.LOAD_CARTS
  }, function (state) {
    return __awaiter(void 0, void 0, void 0, function () {
      var response, response_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , rest_api_1.getCarts(state.auth, queryParameters)];

          case 1:
            response = _a.sent();
            if (!(response.data && response.data.length)) return [3
            /*break*/
            , 4];
            if (!fetchProducts) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , populateCarts(response.data, state)];

          case 2:
            _a.sent();

            _a.label = 3;

          case 3:
            return [2
            /*return*/
            , {
              data: response.data[0]
            }];

          case 4:
            return [4
            /*yield*/
            , rest_api_1.postCart(state.auth, {})];

          case 5:
            response_1 = _a.sent();

            if (response_1.data) {
              return [2
              /*return*/
              , {
                type: actionTypes_1.CREATE_CART,
                data: response_1.data
              }];
            }

            _a.label = 6;

          case 6:
            return [2
            /*return*/
            ];
        }
      });
    });
  });
};

exports.loadCarts = function (queryParameters, populateItems) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.LOAD_CARTS
  }, function (state) {
    return __awaiter(void 0, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , rest_api_1.getCarts(state.auth, queryParameters)];

          case 1:
            response = _a.sent();
            if (!response.data) return [3
            /*break*/
            , 4];
            if (!populateItems) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , populateCarts(response.data, state)];

          case 2:
            _a.sent();

            _a.label = 3;

          case 3:
            return [2
            /*return*/
            , {
              data: response.data
            }];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  });
};

exports.loadCart = function (id, populateItems) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.LOAD_CART
  }, function (state) {
    return __awaiter(void 0, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , rest_api_1.getCart(state.auth, id)];

          case 1:
            response = _a.sent();
            if (!response.data) return [3
            /*break*/
            , 4];
            if (!populateItems) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , populateCart(response.data, state)];

          case 2:
            _a.sent();

            _a.label = 3;

          case 3:
            return [2
            /*return*/
            , {
              data: response.data
            }];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  });
};

exports.createCart = function (data, populateItems) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.CREATE_CART
  }, function (state) {
    return __awaiter(void 0, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , rest_api_1.postCart(state.auth, data)];

          case 1:
            response = _a.sent();
            if (!response.data) return [3
            /*break*/
            , 4];
            if (!populateItems) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , populateCart(response.data, state)];

          case 2:
            _a.sent();

            _a.label = 3;

          case 3:
            return [2
            /*return*/
            , {
              data: response.data
            }];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  });
};

exports.updateCart = function (data, populateItems) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.UPDATE_CART
  }, function (state) {
    return __awaiter(void 0, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , rest_api_1.putCart(state.auth, data)];

          case 1:
            response = _a.sent();
            if (!response.data) return [3
            /*break*/
            , 4];
            if (!populateItems) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , populateCarts([response.data], state)];

          case 2:
            _a.sent();

            _a.label = 3;

          case 3:
            return [2
            /*return*/
            , {
              data: response.data
            }];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  });
};

exports.updateCartItem = function (id, data, populateItems) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.UPDATE_CART
  }, function (state) {
    return __awaiter(void 0, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , rest_api_1.putCartItem(state.auth, id, data)];

          case 1:
            response = _a.sent();
            if (!response.data) return [3
            /*break*/
            , 4];
            if (!populateItems) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , populateCarts([response.data], state)];

          case 2:
            _a.sent();

            _a.label = 3;

          case 3:
            return [2
            /*return*/
            , {
              data: response.data
            }];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  });
};

exports.inactivateCart = function (id) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.INACTIVATE_CART,
    id: id
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.putCartAction(auth, id, 'inactivate');
  });
};